import React, { useState } from "react";
import { CONTACT_PAGE } from "../../content/siteContent";
import { COMPANY } from "../../content/siteContent";

export const ContactAreaOne = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const appsScriptUrl =
    process.env.REACT_APP_CONTACT_APPS_SCRIPT_URL ||
    "https://script.google.com/macros/s/AKfycbyJkQBZavsQMwhcRLzUVx8Gjcfiq8QYz9THErAhRBCkWQTxTZ8C3wAhETTpJB9tqWcm/exec";

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setStatus({
        type: "error",
        message: "Please fill in your name, email address, and message.",
      });
      return;
    }

    if (!appsScriptUrl) {
      setStatus({
        type: "error",
        message: "Contact form is not configured yet. Please try WhatsApp or email instead.",
      });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      await fetch(appsScriptUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify(formData),
      });

      setStatus({
        type: "success",
        message:
          "Your message has been sent successfully. We will contact you on your provided email address soon.",
      });
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error.message ||
          "We could not send your message right now. Please try again or contact us on WhatsApp.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-area contact-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="contact-content">
              <div className="section-title mb-30 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">Contact Us.</span>
                <h2 className="title tg-element-title">
                  Have a question or need help getting started?
                </h2>
              </div>
              <p>{CONTACT_PAGE.intro}</p>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        type="text"
                        name="name"
                        placeholder="Full Name *"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address *"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <input
                        type="text"
                        name="service"
                        placeholder="How Can We Help?"
                        value={formData.service}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-grp">
                      <textarea
                        name="message"
                        placeholder="Message / How Can We Help? *"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
                {status.message ? (
                  <p
                    className="mb-3"
                    style={{
                      color: status.type === "success" ? "#22c55e" : "#ef4444",
                    }}
                  >
                    {status.message}
                  </p>
                ) : null}
                <div className="d-flex flex-wrap gap-3">
                  <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Sending..." : "Send Message"}
                  </button>
                  <a href={COMPANY.whatsappHref} className="btn">
                    Message on WhatsApp
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-shape">
        <img src="/images/home/blue_ball.png" alt="" />
      </div>
    </section>
  );
};
